<template>
  <div class="fix-top-right print-hide-object">
    <div id="ddown-right">
      <div
        class="ddown-menu-button"
        :class="btnMenuClass"
        @click="btnShowMenu = !btnShowMenu"
      >
        <img :src="$config.getAssetsURL(btnMenuImg)" />
      </div>

      <ul
        v-show="btnShowMenu"
        class="
          dropdown-menu dropdown-menu-right
          show
          area-overflow-y
          scroll-style
        "
      >
        <!-- 全螢幕顯示 -->
        <template v-if="expand_button && isFullScreen == false">
          <li class="ddown-link-button" @click="open_Fullscreen">
            <i class="fa fa-arrows-alt"></i> {{ $t("menu.fullscreen") }}
          </li>
        </template>

        <!-- 取消全螢幕顯示 -->
        <template v-if="compress_button || isFullScreen">
          <li class="ddown-link-button" @click="close_Fullscreen">
            <i class="fa fa-compress"></i> {{ $t("menu.cancel") }}
            {{ $t("menu.fullscreen") }}
          </li>
        </template>

        <li
          v-for="(item, idx) in dropdown"
          :key="idx"
          class="ddown-link-button"
        >
          <div v-if="item.type == 'link'" @click="open_new_page(item.href)">
            <i v-if="item.icon" :class="item.icon"></i>
            {{ item.name_code ? $t("menu." + item.name_code) : item.name }}
          </div>

          <div v-else @click="goTO_ID(item.href)">
            <i v-if="item.icon" :class="item.icon"></i>
            {{ item.name_code ? $t("menu." + item.name_code) : item.name }}
          </div>
        </li>
      </ul>
    </div>

    <!-- 阿龜按鈕的 tooltip，但是會挑出找不到 target 警告，所以取消... -->
    <!-- <b-tooltip :show.sync="showTooltip" :target="'ddown-right'" placement="left">
            click <strong>Me</strong> !
        </b-tooltip> -->
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "ButtonTopRight",
  //['dropdown'],
  props: {
    dropdown: {
      type: Array,
      default: function () {
        return [];
      },
    },
    offsetX: {
      type: [Number, String],
      default: 0,
    },
    offsetY: {
      type: [Number, String],
      default: -70,
    },
    expand_button: {
      type: Boolean,
      default: false,
    },
    compress_button: {
      type: Boolean,
      default: false,
    },
    expand_element_id: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      btnShowMenu: true,
      showTooltip: false,
      btnMenuImg: "img/brand/AgriOpenMouth_mirror.png",
      btnMenuClass: "m-2 faa-vertical animated-hover faa-slow",
      elem: undefined,
      isFullScreen: false,
    };
  },
  mounted() {
    /* Get the element you want displayed in fullscreen */
    if (
      this.expand_element_id != undefined &&
      document.getElementById(this.expand_element_id) != undefined
    ) {
      this.elem = document.getElementById(this.expand_element_id);
    } else {
      this.elem = document.documentElement;
    }
  },
  computed: {
    ...mapState({
      user_browser: (state) => state.user.userBrowser,
    }),
  },
  methods: {
    open_new_page(href) {
      window.open(href);
    },

    goTO_ID(divID) {
      this.$tools.ui.goToID(
        divID,
        this.user_browser,
        this.offsetX,
        this.offsetY
      );
    },

    /* Function to open fullscreen mode */
    open_Fullscreen() {
      if (this.elem.requestFullscreen) {
        this.elem.requestFullscreen();
      } else if (this.elem.mozRequestFullScreen) {
        /* Firefox */
        this.elem.mozRequestFullScreen();
      } else if (this.elem.webkitRequestFullscreen) {
        /* Chrome, Safari & Opera */
        this.elem.webkitRequestFullscreen();
      } else if (this.elem.msRequestFullscreen) {
        /* IE/Edge */
        this.elem = window.top.document.body; //To break out of frame in IE
        this.elem.msRequestFullscreen();
      }
      this.isFullScreen = true;
    },

    /* Function to close fullscreen mode */
    close_Fullscreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        window.top.document.msExitFullscreen();
      }
      this.isFullScreen = false;
    },
  },
};
</script>

<style lang="scss">
.fix-top-right {
  position: fixed;
  right: 10px;
  top: 60px;
}

#ddown-right {
  $scroll-color: #46ab7c;

  .scroll-style {
    cursor: pointer !important;
    // CSS Scrollbars Module Level 1
    scrollbar-width: thin;
    scrollbar-color: rgba($scroll-color, 0.8) rgba($scroll-color, 0.5);

    .form-group {
      margin-bottom: 5px;
    }
  }

  .ddown-menu-button {
    cursor: pointer;
    width: 45px;
    height: 45px;
    border-radius: 50%;
    background-color: rgba(#3abb7f, 0.4) !important;
    margin-top: 10px;
    margin-bottom: 4px;

    img {
      width: 40px;
      margin-left: 2px;
      margin-top: 10px;
    }
  }

  ul {
    border: none;
    min-width: 12rem;
    overflow-y: auto;
    max-height: 70vh !important;
    min-height: 50px;
    // max-height: 500px !important;
  }

  .dropdown-menu {
    // top: -3px !important;
    transform: scale(1.03, 1.03);
    border: 1px solid rgba(96, 244, 227, 0.3);

    margin-right: 5px;
  }

  .ddown-link-button {
    position: relative;
    padding: 10px 20px;
    list-style: none;
    cursor: pointer;

    font-size: 1rem;
    color: #dddddd !important;
    background-color: #323332 !important;

    i {
      color: #46ab7c;
      margin-right: 5px !important;
    }

    &:hover,
    &:active,
    &:focus {
      color: #58f5db !important;
      background-color: #1a1a1a !important;

      i {
        color: #f8c41a;
      }
    }
  }

  .ddown-link-button i {
    margin-right: 0px;
  }
}
</style>
